<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-10 13:48:42
-->
<template>
    <div class="header">
        <div class="logo" :class="{'logo_collapse': collapsed}">
            <!-- <img class="logoImg" src="@/assets/image/index-banner-Icon.webp" alt="" width="24" height="26" v-if="!collapsed"> -->
            <img class="logoImg2" src="@/assets/image/hepha-logo-black2.jpg" alt="" width="170" height="60" v-if="!collapsed">
            <icon-sort class="icon_unfold" :class="{'icon_unfold_collapse': collapsed}" :size="20" @click="collapse"/>
        </div>
        <div class="toolbar">
            <a-space size="large">
                <!-- <a-select 
                    v-model="timeZone"
                    :style="{width:'200px',float:'right'}" 
                    placeholder="Select"
                    @change="changeSelectTimeZone"
                >
                    <a-option value="Asia/Shanghai">(UTC+08:00) 北京</a-option>
                    <a-option value="Europe/Berlin">(UTC+01:00) 柏林</a-option>
                </a-select> -->
                <a-select 
                    v-model="language"
                    :style="{width:'120px',float:'right'}" 
                    placeholder="Select"
                    @change="changeSelect"
                >
                    <a-option value="en">English</a-option>
                    <!-- <a-option value="de">Deutsch</a-option> -->
                    <a-option value="zh">简体中文</a-option>
                </a-select>
                <Avatar></Avatar>
            </a-space>
        </div>
    </div>
</template>

<script setup>
    import { ref } from 'vue';
    import Avatar from './Avatar.vue';
    // import { useLocale } from '@/store/index.js';
    import { useI18n } from 'vue-i18n';

    const i18n = useI18n();
    // const locale = useLocale()
    // const timeZone = sessionStorage.getItem('timezone')? ref(sessionStorage.getItem('timezone')) : ref('Asia/Shanghai')

    const language = localStorage.getItem('locale')? ref(localStorage.getItem('locale')) : ref('en')

    const emits = defineEmits(['collapse'])

    const collapsed = ref(false)

    const collapse = ()=>{
        collapsed.value = !collapsed.value
        emits('collapse',collapsed.value)
    }

    const changeSelect = (val)=>{
        localStorage.setItem('locale',val)
        i18n.locale.value = val
        // locale.changeLocale(val)
        location.reload()
    }

    // const changeSelectTimeZone = (val)=>{
    //     timeZone.value = val
    //     sessionStorage.setItem('timezone',val)
    //     location.reload()
    // }

    defineExpose({
        collapsed
    })


    
</script>

<style lang="less" scoped>
.header{
    display: flex;
    height: 45px;
    padding: 0 20px 0 0;
    border-bottom: 1px solid #ddd ;

    .logo{
        display: flex;
        flex:  0 0 230px;
        // margin-left: 20px;
        border-right: 1px solid #ddd;
        justify-content: left;
        align-items: center;
        box-sizing: border-box;

        .logoImg{
            margin-left: 10px;
        }
        .logoImg2{  
            // margin-left: 10px;
        }
        .icon_unfold{
            // margin-left: 40px;
            cursor: pointer;
        }

        .icon_unfold_collapse{
            margin-left: 0;
            box-sizing: border-box;
        }
    }

    .logo_collapse{
        flex:  0 0 55px;
        width: 55px;
        justify-content: center;
    }

    .toolbar{
        display: flex;
        flex: 1;
        justify-content: right;
        align-items: center;
    }

    /deep/ button:focus, 
    /deep/ button:focus-visible {
        outline: none;
    }
}
</style>